export const CheckLogin = "CHECK_LOGIN";
export const AuthenticateSuccess = "AUTHENTICATE_SUCCESS";
export const AuthenticateError = "AUTHENTICATE_ERROR";
export const ToggleContactModal = "TOGGLE_CONTACT_MODAL";
export const ToggleTermsOfUseModal = "TOGGLE_TERMS_OF_USE_MODAL";
export const SetPassword = "SET_PASSWORD";
export const SetPasswordSuccess = "SET_PASSWORD_SUCCESS";
export const SetPasswordError = "SET_PASSWORD_ERROR";
export const SetAccessTokenExpiresAt = "SET_ACCESS_TOKEN_EXPIRES_AT";
export const Impersonate = "IMPERSONATE";
export const ImpersonateSuccess = "IMPERSONATE_SUCCESS";
export const ImpersonateError = "IMPERSONATE_ERROR";

// Account Client Settings
export const GetAccountClientServiceSettings = "GET_ACCOUNT_CLIENT_SERVICE_SETTINGS";
export const GetAccountClientServiceSettingsSuccess = "GET_ACCOUNT_CLIENT_SERVICE_SETTINGS_SUCCESS";
export const GetAccountClientServiceSettingsError = "GET_ACCOUNT_CLIENT_SERVICE_SETTINGS_ERROR";

export const GetAccountAbsenceManagementSettings = "GET_ACCOUNT_ABSENCE_MANAGEMENT_SETTINGS";
export const GetAccountAbsenceManagementSettingsSuccess =
  "GET_ACCOUNT_ABSENCE_MANAGEMENT_SETTINGS_SUCCESS";
export const GetAccountAbsenceManagementSettingsError =
  "GET_ACCOUNT_ABSENCE_MANAGEMENT_SETTINGS_ERROR";
